export const lightTheme = {
  // Core
  background: '#FFFFFF',
  main: '#F7F7F7',
  headline: '#3949AB',
  textColor: '#505050',
  // Buttons
  buttonText: '#FFFFFF',
  buttonBorder: '#2C2C2C',
  buttonStandard: '#5C6D7D',
  buttonStandardHover: '#1A237E',
  buttonPrimary: '#3949AB',
  buttonPrimaryHover: '#1A237E',
  buttonSecondary: '#E53935',
  buttonSecondaryHover: '#C62828',
  buttonBackgroundDisabled: '#B1B1B1',
  // Others
  tertiary: '#689F38',
  extra: '#3949AB',
  // Additional
  transitionSpeed: '0.3s',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  borderColor: '#E0E0E0',
  backgroundAccent: '#F1F1F1',
  backgroundAccentTransparent: 'rgba(241, 241, 241, 0.8)',
  success: '#4CAF50',
  error: '#F44336',
  warning: '#FFC107',
  info: '#2196F3',
};

export const darkTheme = {
  // Core
  background: '#121212',
  main: '#212121',
  headline: '#3949AB',
  textColor: '#BDBDBD',
  // Buttons
  buttonText: '#FFFFFF',
  buttonBorder: '#757575',
  buttonStandard: '#768A9B',
  buttonStandardHover: '#1A237E',
  buttonPrimary: '#3949AB',
  buttonPrimaryHover: '#1A237E',
  buttonSecondary: '#E53935',
  buttonSecondaryHover: '#C62828',
  buttonBackgroundDisabled: '#424242',
  // Others
  tertiary: '#689F38',
  extra: '#3949AB',
  // Additional
  transitionSpeed: '0.3s',
  boxShadow: '0px 4px 6px rgba(255, 255, 255, 0.1)',
  borderColor: '#333333',
  backgroundAccent: '#1E1E1E',
  backgroundAccentTransparent: 'rgba(30, 30, 30, 0.8)',
  success: '#81C784',
  error: '#EF5350',
  warning: '#FFD54F',
  info: '#64B5F6',
};
